module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-info-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_vm._v("\n           Номер лицензии: "), _c('b', [_vm._v(_vm._s(_vm.item.number))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n           с "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.startDate, _vm.formats.formatDate)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.finishDate),
      expression: "item.finishDate"
    }]
  }, [_vm._v(" по "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.finishDate, _vm.formats.formatDate)))])])]), _vm._v(" "), _c('v-flex', [_c('b', [_vm._v(_vm._s(_vm.item.activities.map(function (a) { return a.name; }).join(', ')))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Выдана: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.issued.date, _vm.formats.formatDate)))]), _vm._v(" - " + _vm._s(_vm.item.issued.org) + " \n          ")]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.paused != null),
      expression: "item.paused != null"
    }]
  }, [_vm._v("\n            Приостановлена: "), _c('b', [_vm._v(_vm._s(_vm.item.paused ? _vm.formats.blank(_vm.item.paused.date, _vm.formats.formatDate) : ''))]), _vm._v(" - " + _vm._s(_vm.item.paused ? _vm.item.paused.org : '') + " \n          ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6df6a2c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/LicenseForm.vue
// module id = 1061
// module chunks = 1